(() => {
  const THUMB_PREFIX = 'Slider-Thumbnails-template--'; // stable on Sense

  document.querySelectorAll(`[id^="${THUMB_PREFIX}"]`).forEach((thumbSlider) => {
    const wrapper = thumbSlider.closest('slider-component, .thumbnail-slider') || thumbSlider.parentElement;
    const prevBtn = wrapper && wrapper.querySelector('button.slider-button--prev, .slider-button--prev');
    const nextBtn = wrapper && wrapper.querySelector('button.slider-button--next, .slider-button--next');

    const getThumbs = () => [...thumbSlider.querySelectorAll('button.thumbnail, [data-thumbnail-button]')];
    const getCurrent = () => {
      const t = getThumbs();
      const i = t.findIndex(b => b.getAttribute('aria-current') === 'true' || b.classList.contains('is-active'));
      return i >= 0 ? i : 0;
    };

    function clickRelative(offset) {
      const t = getThumbs();
      if (!t.length) return;
      let i = getCurrent();
      let j = (i + offset + t.length) % t.length;
      t[j].click();                                      // updates the big image
      t[j].scrollIntoView({block:'nearest', inline:'nearest'}); // keep thumb in view

      // keep arrows usable
      [prevBtn, nextBtn].forEach(btn => {
        if (!btn) return;
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-disabled','false');
        btn.style.cursor = ''; // reset any not-allowed cursor
      });
    }

    function bind(btn, offset) {
      if (!btn || btn.__synced) return;
      // Capture + stop theme's handler so it won't disable the button
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        clickRelative(offset);
      }, { capture: true });
      btn.__synced = true;
      // also ensure initially enabled
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled','false');
    }

    bind(prevBtn, -1);
    bind(nextBtn,  1);
  });
})();
